import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { max } from "date-fns";

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const o_type = useRef(null);

    const departments_list = useRef(null);
        
    const type_active = useRef(null);
    const year_active = useRef(null);
    const types_actives = useRef(null);
    const years_actives = useRef(null);
    const dados_actives = useRef(null);

    const dados_stats = useRef(null);
    const dados_stats_department = useRef(null);
    
    const max_number = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [show_stats, set_show_stats] = useState(false);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const [months_list, ] = useState([
        {
            id: '01',
            name: 'Janeiro'
        },
        {
            id: '02',
            name: 'Fevereiro'
        },
        {
            id: '03',
            name: 'Março'
        },
        {
            id: '04',
            name: 'Abril'
        },
        {
            id: '05',
            name: 'Maio'
        },
        {
            id: '06',
            name: 'Junho'
        },
        {
            id: '07',
            name: 'Julho'
        },
        {
            id: '08',
            name: 'Agosto'
        },
        {
            id: '09',
            name: 'Setembro'
        },
        {
            id: '10',
            name: 'Outubro'
        },
        {
            id: '11',
            name: 'Novembro'
        },
        {
            id: '12',
            name: 'Dezembro'
        }
    ])

    const get_info = async () => {

        let res_1 = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/occurrence_type`)
        set_dados(o_type.current = res_1.data)

        let res_2 = await reqGET(`${api_crud_base}/intranet/departments/${getTokenInfo().companycode}`)
        set_dados(departments_list.current = res_2.data)

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined) {
                    setData(res.data);

                    let aux = 0
                    let array_aux = []
                    let array_ano_aux = []
                    res.data.forEach(e => {
                        if(parseInt(e.info.number) > aux) {
                            aux = parseInt(e.info.number)
                        }

                        array_aux = array_aux.filter(e1 => parseInt(e1) !== parseInt(e.info.settings.occurrence_type))
                        array_aux.push(e.info.settings.occurrence_type)

                        if(e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification !== '') {
                            array_ano_aux = array_ano_aux.filter(e1 => parseInt(e1) !== parseInt(e.info.action.identification.responsable.notification.split('-')[0]))
                            array_ano_aux.push(e.info.action.identification.responsable.notification.split('-')[0])
                        }


                    })
                    set_dados(max.current = aux)
                    set_dados(types_actives.current = o_type.current.filter(e => array_aux.includes(e.id)))
                    set_dados(years_actives.current = array_ano_aux)

                    // set_dados(type_active.current = types_actives.current[0].id)
                    set_dados(type_active.current = 0)
                    set_dados(year_active.current = years_actives.current[0])
                    // let aux_2 = res.data.filter(e => parseInt(e.info.settings.occurrence_type) === parseInt(types_actives.current[0].id))
                    let aux_2 = res.data.filter(e => (e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification.includes(years_actives.current[0])))
                    set_dados(dados_actives.current = aux_2) 

                    console.log('array_ano_aux', array_ano_aux)

                }
            })
            .catch(() => 404
            )
    }


    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_state = (element) => {

        let result = '<span className="badge rounded-0 bg-light text-dark p-3 fs-6">' + language[lang].action_not_open + '</span>'

        if(element?.info?.action?.analysis?.ac_am !== undefined) {

            if(element.info.action.analysis.ac_am === true) {

                if(element?.info?.action?.results?.responsable?.execution !== undefined && element?.info?.action?.results?.responsable?.execution !== null && element.info.action.results.responsable.execution !== '') {
                    if(element?.info?.action?.results?.value !== undefined && parseInt(element.info.action.results.value) === 1) {
                        result = '<span className="badge rounded-0 bg-success p-3 fs-6">' + language[lang].effective + '</span>'
                    }
                    else if(element?.info?.action?.results?.value !== undefined && element?.info?.action?.results?.value !== null && parseInt(element.info.action.results.value) === 0) {
                        result = '<span className="badge rounded-0 bg-danger p-3 fs-6">' + language[lang].not_effective + '</span>'
                    }
                }
                else if(element?.info?.action?.improvement?.responsable?.execution !== undefined && element?.info?.action?.improvement?.responsable?.execution !== null && element.info.action.improvement.responsable.execution !== '') {
                    result = '<span className="badge rounded-0 bg-warning text-dark p-3 fs-6">' + language[lang].for_evaluating + '</span>'
                }
                else {
                    result = '<span className="badge rounded-0 bg-orange text-dark p-3 fs-6">' + language[lang].action_to_be_taken + '</span>'
                }

            }
        }

        return result
    }

    const get_type = (id) => {

        if(id !== '') {

            let aux = o_type.current.filter(e => parseInt(e.id) === parseInt(id))

            return aux[0].info.tag
        }
        else {
            return ''
        }

    }

    const change_type = (id) => {

        if(parseInt(id) === 0) {
            set_dados(type_active.current = id)
            let aux = data.filter(e => (e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification.includes(year_active.current)))
            set_dados(dados_actives.current = aux)   
        }
        else {
            set_dados(type_active.current = id)
            let aux = data.filter(e => (parseInt(e.info.settings.occurrence_type) === parseInt(id) && e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification.includes(year_active.current)))
            set_dados(dados_actives.current = aux)   

        }

        change_year(year_active.current)

    }

    const order_array = (array, type) => {

        return array.sort((a, b) => {
			const nameA = a.info[type].toUpperCase(); // ignore upper and lowercase
			const nameB = b.info[type].toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

    const change_year = async (id) => {

        if(parseInt(type_active.current) === 0) {
            set_dados(year_active.current = id)
            let aux = data.filter(e => (e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification.includes(id)))
            set_dados(dados_actives.current = aux)   
        }
        else {
            set_dados(year_active.current = id)
            let aux = data.filter(e => (parseInt(e.info.settings.occurrence_type) === parseInt(type_active.current) && e?.info?.action?.identification?.responsable?.notification !== undefined && e.info.action.identification.responsable.notification.includes(id)))
            set_dados(dados_actives.current = aux)   
        }

        let array_o = []
        let array_o_department = []
        if(dados_actives?.current !== undefined && dados_actives?.current !== null && Array.isArray(dados_actives.current)) {
            for await (let el of dados_actives.current) {

                let array_o_aux = array_o[el.info.settings.occurrence_type] !== undefined && array_o[el.info.settings.occurrence_type] !== null ? array_o[el.info.settings.occurrence_type].filter(e => ((parseInt(e.info.year) === parseInt(id)) && (parseInt(e.info.type) === parseInt(el.info.settings.occurrence_type)) && (parseInt(e.info.month) === parseInt(el.info.action.identification.responsable.notification.split('-')[1])))) : []
                if(Array.isArray(array_o_aux) && array_o_aux.length === 0) {

                    let cost_total = 0.00
                    if(el?.action?.immediate_action?.cost !== undefined && el.info.action.immediate_action.cost !== '') {
                        cost_total += parseFloat(el.info.action.immediate_action.cost)
                    }
                    if(el?.action?.analysis?.cost !== undefined && el.info.action.analysis.cost !== '') {
                        cost_total += parseFloat(el.info.action.analysis.cost)
                    }
                    if(el?.action?.improvement?.cost !== undefined && el.info.action.improvement.cost !== '') {
                        cost_total += parseFloat(el.info.action.improvement.cost)
                    }

                    if(array_o[el.info.settings.occurrence_type] === undefined || array_o[el.info.settings.occurrence_type] === null) {
                        array_o[el.info.settings.occurrence_type] = []
                    }
                    array_o[el.info.settings.occurrence_type].push({
                        id: Date.now(),
                        info: {
                            year: id,
                            month: el?.info?.action?.identification?.responsable?.notification !== undefined ? el.info.action.identification.responsable.notification.split('-')[1] : '',
                            type: el.info.settings.occurrence_type,
                            o_n: 1,
                            o_n_open: el?.info?.action?.analysis?.ac_am !== undefined && el.info.action.analysis.ac_am === true ? 1 : 0,
                            o_n_closed: el?.info?.action?.closing?.responsable?.deadline !== undefined && el.info.action.closing.responsable.deadline !== '' ? 1 : 0,
                            o_cost: cost_total,
                            o_effectiveness: el?.info?.action?.results?.value !== undefined && parseInt(el.info.action.results.value) === 1 ? 1 : 0,
                        }
                    })


                    if(array_o_department[el.info.settings.occurrence_type] === undefined || array_o_department[el.info.settings.occurrence_type] === null) {
                        array_o_department[el.info.settings.occurrence_type] = []
                    }
                    array_o_department[el.info.settings.occurrence_type].push({
                        id: Date.now(),
                        info: {
                            year: id,
                            month: el?.info?.action?.identification?.responsable?.notification !== undefined ? el.info.action.identification.responsable.notification.split('-')[1] : '',
                            type: el.info.settings.occurrence_type,
                            department: el.info.settings.occurrence_department,
                            o_n: 1
                        }
                    })

                }
                else {
                    array_o[el.info.settings.occurrence_type].forEach(el_2 => {
                        if(parseInt(el_2.info.year) === parseInt(id) && (parseInt(el_2.info.type) === parseInt(el.info.settings.occurrence_type)) && parseInt(el_2.info.month) === parseInt(el.info.action.identification.responsable.notification.split('-')[1])) {

                            let cost_total = 0.00
                            if(el?.info?.action?.immediate_action?.cost !== undefined && el.info.action.immediate_action.cost !== '') {
                                cost_total += parseFloat(el.info.action.immediate_action.cost)
                            }
                            if(el?.info?.action?.analysis?.cost !== undefined && el.info.action.analysis.cost !== '') {
                                cost_total += parseFloat(el.info.action.analysis.cost)
                            }
                            if(el?.info?.action?.improvement?.cost !== undefined && el.info.action.improvement.cost !== '') {
                                cost_total += parseFloat(el.info.action.improvement.cost)
                            }

                            el_2.info.o_n = parseInt(el_2.info.o_n) + 1
                            el_2.info.o_cost = parseFloat(el_2.info.o_cost) + cost_total

                            if(el?.info?.action?.analysis?.ac_am !== undefined && el.info.action.analysis.ac_am === true) {
                                el_2.info.o_n_open = parseInt(el_2.info.o_n_open) + 1
                            }
                            if(el?.info?.action?.closing?.responsable?.deadline !== undefined && el.info.action.closing.responsable.deadline !== '') {
                                el_2.info.o_n_closed = parseInt(el_2.info.o_n_closed) + 1
                            }
                            if(el?.info?.action?.results?.value !== undefined && parseInt(el.info.action.results.value) === 1) {
                                el_2.info.o_effectiveness = parseInt(el_2.info.o_effectiveness) + 1
                            }

                        }
                    })
                    array_o_department[el.info.settings.occurrence_type].forEach(el_2 => {
                        if(parseInt(el_2.info.year) === parseInt(id) && (parseInt(el_2.info.type) === parseInt(el.info.settings.occurrence_type)) && parseInt(el_2.info.month) === parseInt(el.info.action.identification.responsable.notification.split('-')[1]) && parseInt(el_2.info.department) === parseInt(el.info.settings.occurrence_department)) {

                            el_2.info.o_n = parseInt(el_2.info.o_n) + 1

                        }
                    })
                }

            }
        }
        for await (let el of array_o) {
            if(el !== undefined && el !== null) {
                el = order_array(el, 'month')
            }
        }

        // console.log('array_o', array_o)
        // console.log('array_o_department', array_o_department)

        set_dados(dados_stats.current = array_o)
        set_dados(dados_stats_department.current = array_o_department)

    }

    const get_type_name = (id) => {

        let result = ''
        o_type.current.forEach(el => {
            if(parseInt(el.id) === parseInt(id)) {
                result = el.info.name
            }
        })
        return result
    }

    const get_month_name = (id) => {

        let result = ''
        months_list.forEach(el => {
            if(parseInt(el.id) === parseInt(id)) {
                result = el.name
            }
        })
        return result

    }

    const columns = [
        {
            name: language[lang].field_number,
            selector: 'info.number',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_type,
            selector: 'info.settings.occurrence_type',
            cell: row => (
                get_type(row.info.settings.occurrence_type)
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.action.identification.notification',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                    {row?.info?.action?.identification?.responsable?.notification !== undefined && row.info.action.identification.responsable.notification !== '' ? row.info.action.identification.responsable.notification.split('T')[0] : ''}
                </span>
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '45% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_state,
            cell: row => (
                parse(get_state(row))
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: dados_actives.current !== undefined && dados_actives.current !== null ? dados_actives.current : [],
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const change_show_stats = () => {

        if(show_stats) {
            change_type(0)
        }
        else {
            change_type(types_actives.current[0].id)
        }

        change_year(year_active.current)

        set_show_stats(!show_stats)

    } 

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-3">
                                        <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                            to={{ pathname: endpoints.regist, state: { item: {number: max.current}} }}
                                            style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                        >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body occorrence-list">

                                        <div className="row">
                                            <div className="col-10 mb-3 d-flex">
                                                {
                                                years_actives.current !== undefined && years_actives.current !== null ?
                                                    years_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(dt_el)} >{parseInt(dt_el)}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                            </div>
                                            <div className="col-2 text-end mb-3">
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (show_stats ? ' active' : '')} onClick={() => change_show_stats()}>{show_stats ? language[lang].show_occurrences : language[lang].show_stats}</button>
                                                </div>
                                            </div>
                                            <div className="col-12 mb-3 d-flex">
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (show_stats ? ' d-none' : '') + (types_actives.current !== undefined && types_actives.current !== null && parseInt(type_active.current) === 0 ? ' active' : '') } onClick={() => change_type(0)} >{language[lang].table_all}</button>
                                                </div>
                                                {
                                                types_actives.current !== undefined && types_actives.current !== null ?
                                                    types_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.id) === parseInt(type_active.current) ? ' active' : '') } onClick={() => change_type(dt_el.id)} >{dt_el.info.name}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>

                                        {
                                        !show_stats ?
                                            <div className={"row" + (show_stats ? ' d-none' : '')}>
                                                <div className="col-12">
                                                    <DataTableExtensions {...tableData}>
                                                        <DataTable
                                                            noDataComponent={language[lang].table_empty}
                                                            noHeader
                                                            defaultSortField="info.number"
                                                            defaultSortAsc={true}
                                                            pagination
                                                            exportHeaders
                                                            paginationComponentOptions={defaultComponentOptions}
                                                            paginationPerPage={25}
                                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                                        />
                                                    </DataTableExtensions>
                                                </div>
                                            </div>
                                        :
                                            <div className={"row" + (show_stats ? '' : ' d-none')}>
                                                <div className="col-12">
                                                    <div className="div-table">
                                                        <div className="table-header text-end mb-8">
                                                        </div>
                                                        <div className="table-body audit-management-list">
                                                            <div className="row">
                                                                {
                                                                dados_stats.current !== undefined && dados_stats.current !== null ?
                                                                    dados_stats.current.map((el_ds, k_ds) => {
                                                                        if(parseInt(type_active.current) === parseInt(el_ds[0].info.type)) {
                                                                            return (
                                                                                <div key={k_ds} className="col-12 mb-3">
                                                                                    <div className="mb-5"> 
                                                                                        <div className="div-table">
                                                                                            <div className="table-header text-ebter mb-8 d-none">
                                                                                                {get_type_name(el_ds[0].info.type)}
                                                                                            </div>
                                                                                            <div className="table-body table-responsive">
                                                                                                <table className="table audit-management-list table-hover table-bordered align-middle">
                                                                                                    <thead className="text-center align-middle">
                                                                                                        <tr>
                                                                                                            <th rowSpan={2}></th>
                                                                                                            <th colSpan={3}></th>
                                                                                                            <th rowSpan={2}>Custo</th>
                                                                                                            <th colSpan={2}>Eficácia</th>
                                                                                                        </tr>
                                                                                                        <tr>
                                                                                                            <th>N.º</th>
                                                                                                            <th>Abertas</th>
                                                                                                            <th>Fechadas</th>
                                                                                                            <th>N.º Eficazes</th>
                                                                                                            <th>Tx Eficácia</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {
                                                                                                        ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((el_m, k_m) => {
                                                                                                            return (
                                                                                                                el_ds.filter(_e_ => parseInt(_e_.info.month) === parseInt(el_m)).length > 0 ?
                                                                                                                    el_ds.map((el_ds_2, k_ds_2) => {
                                                                                                                        if(parseInt(el_m) === parseInt(el_ds_2.info.month)) {
                                                                                                                            return (
                                                                                                                                <tr key={k_ds_2}>
                                                                                                                                    <td>{get_month_name(el_ds_2.info.month)}</td>
                                                                                                                                    <td className="text-center">{el_ds_2.info.o_n}</td>
                                                                                                                                    <td className="text-center">{el_ds_2.info.o_n_open}</td>
                                                                                                                                    <td className="text-center">{el_ds_2.info.o_n_closed}</td>
                                                                                                                                    <td className="text-center">{parseFloat(el_ds_2.info.o_cost).toFixed(2)}€</td>
                                                                                                                                    <td className="text-center">{el_ds_2.info.o_effectiveness}</td>
                                                                                                                                    <td className="text-center">{parseFloat(parseInt(el_ds_2.info.o_n_closed) * 100 / parseInt(el_ds_2.info.o_n_open)).toFixed(2)}%</td>
                                                                                                                                </tr>
                                                                                                                            )
                                                                                                                        }
                                                                                                                    })
                                                                                                                :
                                                                                                                    <tr key={k_m}>
                                                                                                                        <td>{get_month_name(el_m)}</td>
                                                                                                                        <td className="text-center">0</td>
                                                                                                                        <td className="text-center">0</td>
                                                                                                                        <td className="text-center">0</td>
                                                                                                                        <td className="text-center">0.00€</td>
                                                                                                                        <td className="text-center">0</td>
                                                                                                                        <td className="text-center">0.00%</td>
                                                                                                                    </tr>
                                                                                                            )
                                                                                                        })
                                                                                                        }
                                                                                                    </tbody>
                                                                                                    <tfoot>
                                                                                                        <tr>
                                                                                                            <th>TOTAL</th>
                                                                                                            <th className="text-center">{el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n), 0)}</th>
                                                                                                            <th className="text-center">{el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n_open), 0)}</th>
                                                                                                            <th className="text-center">{el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n_closed), 0)}</th>
                                                                                                            <th className="text-center">{el_ds.reduce((a, b) => parseFloat(a) + parseFloat(b.info.o_cost), 0).toFixed(2)}€</th>
                                                                                                            <th className="text-center">{el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_effectiveness), 0)}</th>
                                                                                                            <th className="text-center">{parseFloat((el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n_closed), 0)) * 100 / (el_ds.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n_open), 0))).toFixed(2)}%</th>
                                                                                                        </tr>
                                                                                                    </tfoot>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return null
                                                                        }
                                                                    })
                                                                :
                                                                    null
                                                                }
                                                                
                                                                {
                                                                dados_stats_department.current !== undefined && dados_stats_department.current !== null ?
                                                                    dados_stats_department.current.map((el_dsm, k_dsm) => {
                                                                        if(parseInt(type_active.current) === parseInt(el_dsm[0].info.type)) {
                                                                            return (
                                                                                <div key={k_dsm} className="col-12 mb-3">
                                                                                    <div className="mb-5"> 
                                                                                        <div className="div-table">
                                                                                            <div className="table-header text-ebter mb-8 d-none">
                                                                                                {get_type_name(el_dsm[0].info.type)}
                                                                                            </div>
                                                                                            <div className="table-body table-responsive">
                                                                                                <table className="table audit-management-list table-hover table-bordered align-middle">
                                                                                                    <thead className="text-center align-middle">
                                                                                                        <tr>
                                                                                                            <th></th>
                                                                                                            <th>Jan</th>
                                                                                                            <th>Fev</th>
                                                                                                            <th>Mar</th>
                                                                                                            <th>Abr</th>
                                                                                                            <th>Mai</th>
                                                                                                            <th>Jun</th>
                                                                                                            <th>Jul</th>
                                                                                                            <th>Ago</th>
                                                                                                            <th>Set</th>
                                                                                                            <th>Out</th>
                                                                                                            <th>Nov</th>
                                                                                                            <th>Dez</th>
                                                                                                            <th>TOTAL</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {
                                                                                                        departments_list?.current !== undefined && departments_list?.current !== null ?
                                                                                                            departments_list.current.map((el_d, k_d) => {
                                                                                                                return (
                                                                                                                    <tr key={k_d}>
                                                                                                                        <td>{el_d.info.name}</td>
                                                                                                                        {
                                                                                                                        ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((el_m, k_m) => {
                                                                                                                            return (
                                                                                                                                el_dsm.filter(_e_ => parseInt(_e_.info.month) === parseInt(el_m) && parseInt(el_d.id) === parseInt(_e_.info.department)).length > 0 ?
                                                                                                                                    el_dsm.map((el_dsm_2, k_dsm_2) => {
                                                                                                                                        if(parseInt(el_m) === parseInt(el_dsm_2.info.month) && parseInt(el_d.id) === parseInt(el_dsm_2.info.department)) {
                                                                                                                                            return (
                                                                                                                                                <td key={k_dsm_2} className="text-center">{el_dsm_2.info.o_n}</td>
                                                                                                                                            )
                                                                                                                                        }
                                                                                                                                        else 
                                                                                                                                            return null
                                                                                                                                    })
                                                                                                                                :
                                                                                                                                    <td key={k_m} className="text-center">0</td>
                                                                                                                            )
                                                                                                                        })
                                                                                                                        }
                                                                                                                        <th className="text-center">{el_dsm.filter(_e_ => parseInt(el_d.id) === parseInt(_e_.info.department)).reduce((a, b) => parseInt(a) + parseInt(b.info.o_n), 0)}</th>
                                                                                                                    </tr>
                                                                                                                )
                                                                                                            })
                                                                                                        :
                                                                                                            null
                                                                                                        }
                                                                                                    </tbody>
                                                                                                    <tfoot>
                                                                                                        <tr>
                                                                                                            <th>TOTAL</th>
                                                                                                            {
                                                                                                            ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((el_m, k_m) => {
                                                                                                                return (
                                                                                                                    el_dsm.filter(_e_ => parseInt(_e_.info.month) === parseInt(el_m)).length > 0 ?
                                                                                                                        el_dsm.map((el_dsm_2, k_dsm_2) => {
                                                                                                                            if(parseInt(el_m) === parseInt(el_dsm_2.info.month)) {
                                                                                                                                return (
                                                                                                                                    <th key={k_dsm_2} className="text-center">{el_dsm_2.info.o_n}</th>
                                                                                                                                )
                                                                                                                            }
                                                                                                                            else 
                                                                                                                                return null
                                                                                                                        })
                                                                                                                    :
                                                                                                                        <th key={k_m} className="text-center">0</th>
                                                                                                                )
                                                                                                            })
                                                                                                            }
                                                                                                            <th className="text-center">{el_dsm.reduce((a, b) => parseInt(a) + parseInt(b.info.o_n), 0)}</th>
                                                                                                        </tr>
                                                                                                    </tfoot>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return null
                                                                        }
                                                                    })
                                                                :
                                                                    null
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}